var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCitationWrapperIconMobileView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29989",
    "data-name": "Group 29989",
    transform: "translate(-918 -182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7844",
    "data-name": "Rectangle 7844",
    width: 26,
    height: 25,
    rx: 12.5,
    transform: "translate(918 182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28902",
    "data-name": "Group 28902",
    transform: "translate(8696.887 -1063.895)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15647",
    "data-name": "Ellipse 15647",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7768 1249)",
    fill: "#63666a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15648",
    "data-name": "Ellipse 15648",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7768 1256.807)",
    fill: "#63666a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15649",
    "data-name": "Ellipse 15649",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-7768 1264.614)",
    fill: "#63666a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitationWrapperIconMobileView);
export default __webpack_public_path__ + "static/media/citation-wrapper-icon-mobile-view.94081226a3f273906ecf5ae52c0ebf53.svg";
export { ForwardRef as ReactComponent };